/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

// export const GET_APPLICATION_TABLE = gql`

// query GetCertificateTable($skip: Int, $limit: Int){
//  getCertificateTable(skip: $skip, limit: $limit) {
//       pageSize
//       totalCount
//       currentPage
//       totalPages
//       data
//     }
//  }
// `;

export const GET_CERTIFICATES_TABLE = gql`

query GetCertificateTable($criteria: criteriaCertificate, $skip: Int, $limit: Int) {
  getCertificateTable(criteria: $criteria, skip: $skip, limit: $limit) {
    currentPage
    pageSize
    totalCount
    totalPages
    data
  }
}
 
`;